// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  features/financeiro/services/pagamentoLoteService.ts
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';

const BASE = '/api/pagamento-lote';

export interface ContaPagavel {
  id: number;
  fornecedorId: number;
  nomeFornecedor: string;
  cnpjCpfFornecedor: string | null;
  numDocumento: string;
  dtEmissao: string;
  dtVencimento: string;
  valorOriginal: number;
  valorSaldo: number;
  diasAtraso: number;
  formaPagamentoId: number | null;
}

export interface GrupoFornecedor {
  fornecedorId: number;
  nomeFornecedor: string;
  qtdContas: number;
  total: number;
}

export interface PreviewLote {
  qtdContas: number;
  totalGeral: number;
  totalVencido: number;
  totalFuturo: number;
  saldoConta: number | null;
  saldoAposPagamento: number | null;
  porFornecedor: GrupoFornecedor[];
  avisos: string[];
}

export interface ExecucaoLote {
  processadas: number;
  ignoradas: number;
  totalPago: number;
  dtPagamento: string;
  mensagem: string;
}

export interface BuscarParams {
  dtVencInicio?: string;
  dtVencFim?: string;
  fornecedorId?: number;
  bancoId?: number;
  valorMinimo?: number;
  valorMaximo?: number;
  status?: 'abertas' | 'vencidas' | 'futuras' | 'todas';
  limit?: number;
}

export const pagamentoLoteService = {
  async buscar(params: BuscarParams): Promise<ContaPagavel[]> {
    const { data } = await apiClient.get<ContaPagavel[]>(`${BASE}/buscar`, { params });
    return data;
  },

  async preview(ids: number[], contaCorrenteId?: number): Promise<PreviewLote> {
    const { data } = await apiClient.post<PreviewLote>(`${BASE}/preview`, { ids, contaCorrenteId });
    return data;
  },

  async executar(req: {
    ids: number[];
    dtPagamento: string;
    formaPagamentoId?: number;
    contaCorrenteId?: number;
    observacao?: string;
  }): Promise<ExecucaoLote> {
    const { data } = await apiClient.post<ExecucaoLote>(`${BASE}/executar`, req);
    return data;
  },
};
